<perfect-scrollbar class="legal--wrap">
  <div class="legal--content">
    <div [innerHTML]="termsAndConditions" *ngIf="termsAndConditions"></div>
  </div>
</perfect-scrollbar>
<div class="checkbox-margin">
  <dcs-checkbox
    [ngClass]="{
      invalid: this.field.formControl?.touched && required && !checked
    }"
    [label]="'Yes, I agree'"
    [name]="name"
    [checked]="checked"
    (onCheckboxChangeEvent)="onCheckboxChangeEvent($event)"
  >
  </dcs-checkbox>
  <span *ngIf="!required" class="sc-ds-text-field optional"> (Optional)</span>
</div>
